var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty"},[_c('jd-image',{attrs:{"src":_vm.$globalCdn + '/images/leftOrNoCxt.png',"customStyle":{width: '186px', height: '114px'},"alt":""}}),_c('span',{staticClass:"empty-text"},[_vm._v("暂无数据")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }